module.exports = __webpack_public_path__ + "static/media/auddzh.0b426aa4.svg";